import { populate } from 'populate';import dragonBones from 'pixi-dragonbones';

const raw = {
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: '3b389893-d127-4e29-8a22-0c8d568221f8',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '652d485f-ba17-4010-bbee-68e83f339b84',
      type: 'Sprite',
      name: 'slot',
      nameSpace: '',
      className: 'fence',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'Polygon',
        path: '0,25, 40,25, 40,110,-40,110, -40,25, 0,25'
      },
      texture: 'base_texture',
      parent: '3b389893-d127-4e29-8a22-0c8d568221f8',
      data: ''
    },
    {
      id: 'ad0b8644-256a-4eff-b65e-dc0ebcaf70a5',
      type: 'Container',
      name: 'itemContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '652d485f-ba17-4010-bbee-68e83f339b84',
      data: ''
    },
    {
      id: '7d48f74a-85e6-4e8d-88ad-5da80af23261',
      type: 'Container',
      name: 'taskIcon',
      nameSpace: '',
      className: '',
      x: 0,
      y: 90,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '652d485f-ba17-4010-bbee-68e83f339b84',
      data: ''
    },
    {
      id: 'cb9fef5e-06c8-4bf5-b7b3-f50c6856dd60',
      type: 'Container',
      name: 'replyTaskIcon',
      nameSpace: '',
      className: '',
      x: 0,
      y: 90,
      scale: {
        x: 0.75,
        y: 0.75
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '652d485f-ba17-4010-bbee-68e83f339b84',
      data: ''
    },
    {
      id: 'db48635d-e3ed-4be7-8b90-3da278ded671',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -27,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'reply_task_bg',
      parent: '7d48f74a-85e6-4e8d-88ad-5da80af23261',
      data: ''
    },
    {
      id: '8367a3bd-94ca-4aff-a816-1f950c0cfc45',
      type: 'Sprite',
      name: 'notification',
      nameSpace: '',
      className: '',
      x: 6,
      y: -80,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'notification',
      parent: '7d48f74a-85e6-4e8d-88ad-5da80af23261',
      data: ''
    },
    {
      id: '04a9727e-fd7d-45f3-bc36-f4709592ea64',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -27,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'reply_task_bg',
      parent: 'cb9fef5e-06c8-4bf5-b7b3-f50c6856dd60',
      data: ''
    },
    {
      id: 'd094bc0b-9886-478a-8de2-588f51af6301',
      type: 'Sprite',
      name: 'notification_reply',
      nameSpace: '',
      className: '',
      x: 9,
      y: -86,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.33,
        y: 1.33
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'notification',
      parent: 'cb9fef5e-06c8-4bf5-b7b3-f50c6856dd60',
      data: ''
    },
    {
      id: 'd187c811-421d-42af-b7b9-f1047b382636',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -1,
      y: -3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'reply_task_fence',
      parent: 'db48635d-e3ed-4be7-8b90-3da278ded671',
      data: ''
    },
    {
      id: '66f34045-5342-4fb0-8847-c125d11961de',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -1,
      y: -3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'reply_task_fence',
      parent: '04a9727e-fd7d-45f3-bc36-f4709592ea64',
      data: ''
    },
    {
      id: '9068aa27-825d-480d-82fb-098562e9e6ed',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 25,
      y: 17,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'reply_task',
      parent: '04a9727e-fd7d-45f3-bc36-f4709592ea64',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class FenceSlotLayout {
  static raw = raw;
  root: PIXI.Container
  slot: PIXI.Sprite
  itemContainer: PIXI.Container
  taskIcon: PIXI.Container
  notification: PIXI.Sprite
  replyTaskIcon: PIXI.Container
  notification_reply: PIXI.Sprite
  fence: (PIXI.Sprite)[]

  constructor() {
    populate(this, raw);
  }
}
